module.exports = __webpack_public_path__ + "fonts/Manrope-700-cyrillic-ext19_6b3b5bc.woff2";